import { useEffect } from "react";
import { useSession } from "@/lib/store/session";
import { isNative } from "@/lib/native/capacitor";
import { syncWebPushRegistration } from "@/lib/web/webPush";

/**
 * Browser-push counterpart of NativeBridge (#385): whenever someone is signed
 * in on the web, an existing push subscription is re-linked to that account.
 * Renders nothing; no-op inside the native shells.
 */
export function WebPushBridge() {
  const userId = useSession((s) => s.userId);
  useEffect(() => {
    if (!userId || isNative()) return;
    void syncWebPushRegistration();
  }, [userId]);
  return null;
}
